import { TESTIMONIALS } from "../data/content";
import { Reveal, SectionHeader } from "./ui-bits";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeader
          index="08"
          station="Field Reports"
          id="PROOF // FROM THE TRAIL"
          title={<>Field Notes<br /><span className="text-ember">Client Feedback</span></>}
          sub="What clients and teammates radio back after an expedition together."
        />
        <div className="grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.id} delay={0.1 + i * 0.1} className="h-full">
              <figure
                className="group relative flex h-full flex-col border border-white/10 bg-ink/70 p-7 transition-colors duration-300 hover:border-ember/50"
                data-testid={`testimonial-card-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[9px] font-bold tracking-[0.3em] text-ember">FIELD REPORT 0{i + 1}</span>
                  <span className="flex gap-1.5" aria-hidden="true">
                    {[0, 1, 2].map((s) => (
                      <span key={s} className="h-1.5 w-1.5 rotate-45 bg-ember/80" />
                    ))}
                  </span>
                </div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-white/85" data-testid={`testimonial-quote-${i + 1}`}>
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-dashed border-white/15 pt-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-ember/40 bg-ember/10 font-display text-sm font-black text-ember">
                    {t.name.split(" ").map((w) => w[0]).join("")}
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-bold text-white">{t.name}</span>
                    <span className="block truncate font-mono text-[8px] tracking-[0.2em] text-slate-500">{t.role.toUpperCase()}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
